import React from 'react';
import { SearchSelect } from '../ui/SearchSelect';
import { MicDevice } from './useAudioInputController';

interface MicDevicePickerProps {
    devices: MicDevice[];
    selectedDeviceId: string;
    onSelect: (deviceId: string) => void;
}

// Reuses the shared SearchSelect instead of a bespoke react-bootstrap Dropdown.
export default function MicDevicePicker({ devices, selectedDeviceId, onSelect }: MicDevicePickerProps) {
    if (devices.length === 0) {
        return (
            <div className="text-center py-4" style={{ color: '#90a0b7', fontSize: '13px' }}>
                Loading microphones...
            </div>
        );
    }

    return (
        <div style={{ width: 220, flexShrink: 0 }}>
            <SearchSelect
                options={devices.map(d => ({ value: d.deviceId, label: d.label }))}
                value={selectedDeviceId}
                onChange={onSelect}
                placeholder="Select a microphone"
            />
        </div>
    );
}
